<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="10">
        <div class="mt-6 pa-4 grid_flex justify-start">
          <div class="pa-4 header">
            <span style="font-size: 24px">รายการสินค้า</span>
          </div>
          <!--                    <div class="text-right grid_half justify-end">-->
          <!--                        <router-link to="/stock/storage/productdamaged">-->
          <!--                            <v-btn x-large class="waiting_btn"><div class="count_all filled_orange">100</div>สินค้าชำรุดรอย้ายเข้าคลังรอคืน</v-btn>-->
          <!--                        </router-link>-->
          <!--                        <router-link to="/stock/storage/dropproduct">-->
          <!--                            <v-btn x-large class="filled_btn"><div class="count_all filled_red">100</div>สินค้าชำรุดคืนไม่ได้รอย้ายเข้าคลังทิ้ง</v-btn>-->
          <!--                        </router-link>-->
          <!--                    </div>-->
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="expireHeaders" :items="expireList" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
<!--                <td><v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.product_id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch></td>-->
                <td style="color: red">{{ dataDetail.item.sum }}</td>
                <td class="pa-3"><v-btn @click="getDetails(dataDetail.item.product_id)" class="pa-6 grad-success-bg white--text"><v-icon>mdi-magnify</v-icon> ดูรายละเอียด</v-btn></td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Damaged_stock",
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      expireHeaders: [
        {
          text: 'รหัส',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        // {
        //   text: 'สถานะขาย',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '120px',
        // },
        {
          text: 'ชำรุด',
          value: '',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '110px',
        },
      ],
      expireList: [],
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/getdamagestorage')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.expireList = res.data.object
            }
          })
    },
    changeStatus(product_id, status) {
      if (status == true) {
        this.status_id = 1;
      }
      else if (status == false) {
        this.status_id = 0;
      }
      this.disabled_status = true
      HTTP.post('/products/product/changestatus', {
        status: this.status_id,
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true){
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.disabled_status = false
            this.getProduct()
          })
        }
      })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/DamagedDetail/' + id);
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.count_all{
  border: 3px solid;
  border-radius: 20px;
  padding: 5px;
  margin-right: 5px;
}
.filled_btn {
  font-size: 18px;
  width: 90%;
  border: 2px solid red;
  color: red;
  background-color: white !important;
}
.filled_red {
  background-color: red;
  border: 2px solid red;
  color: white;
}
.waiting_btn {
  font-size: 18px;
  width: 90%;
  border: 2px solid #ffa44d;
  color: #ffa44d;
  background-color: white !important;
}
.filled_orange {
  background-color: #ffa44d;
  border: 2px solid #ffa44d;
  color: white;
}
.header {
  display: grid;
  grid-template-columns: 100%;
  width: 100%;
}
.grid_flex {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 20% 80%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 1100px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .filled_btn {
    font-size: 18px;
    width: 95%;
    border: 2px solid red;
    color: red;
    background-color: white !important;
  }
  .waiting_btn {
    font-size: 18px;
    width: 100%;
    border: 2px solid #ffa44d;
    color: #ffa44d;
    background-color: white !important;
  }
}
@media only screen and (max-width: 810px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .filled_btn {
    font-size: 18px;
    width: 100%;
    border: 2px solid red;
    color: red;
    background-color: white !important;
  }
  .waiting_btn {
    font-size: 18px;
    width: 100%;
    border: 2px solid #ffa44d;
    color: #ffa44d;
    background-color: white !important;
  }
}
</style>
